import { Skeleton, Stack , useMantineTheme} from '@mantine/core';

import HomeCarousel from './HomeCarousel';

interface ContestCardPlaceholderProps {
  count: number;
}

function ContestCardPlaceholder({ count }: ContestCardPlaceholderProps) {
  const theme = useMantineTheme();
  return (
    <HomeCarousel>
      {Array.from({ length: count }, (_, index) => (
        <HomeCarousel.Slide key={`placeholder-${index}`}>
          <Stack spacing="sm" p="md" style={{ borderRadius: theme.radius.md, border: '1px solid #e9ecef' }}>
            <Skeleton height={120} radius="sm" />
            <Skeleton height={20} width="80%" />

            <Stack spacing="xs">
              <Skeleton height={16} width="60%" />
            </Stack>

            <Skeleton height={36} width="100%" radius="sm" />
          </Stack>
        </HomeCarousel.Slide>
      ))}
    </HomeCarousel>
  );
}

export default ContestCardPlaceholder;
